import { stripUrlHashAndQuery } from '@portal/state/utils/urlHelpers';
import { ShopifyProductVariant } from '@portal/api/shopifyV2/types';
import { FREE_SHOPIFY_PRODUCT_IDENTIFIERS } from '@portal/shared/components/ContentBlocks/shared/constants';

export const isOfferlessCheckoutLink = (link: string) =>
  /\/(build-a-bundle|cart\/042)(-\w+)*$/.test(stripUrlHashAndQuery(link));

export const isFreeShopifyVariant = (variantData: ShopifyProductVariant) => {
  return variantData.product.tags.some((x) => FREE_SHOPIFY_PRODUCT_IDENTIFIERS.includes(x));
};
